var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 10,
    ry: 10,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_237_1595)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1728,
    height: 1197,
    transform: "translate(-476 -176)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -476,
    y: -130,
    width: 1728,
    height: 1151,
    rx: 10,
    ry: 10,
    fill: "#F5F6FA"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_237_1595)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -195,
    y: -25,
    width: 260,
    height: 145,
    rx: 10,
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-9 21V41C-9 46.5228 -4.52285 51 1 51H21H41C46.5228 51 51 46.5228 51 41V21V1C51 -4.52285 46.5228 -9 41 -9H21H1C-4.52285 -9 -9 -4.52285 -9 1V21Z",
    fill: "#8280FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6248 36.75V23.625C23.6248 23.2769 23.7631 22.9431 24.0093 22.6969C24.2554 22.4508 24.5892 22.3125 24.9373 22.3125H30.1873C30.5354 22.3125 30.8693 22.4508 31.1154 22.6969C31.3616 22.9431 31.4998 23.2769 31.4998 23.625V36.75M23.6248 36.75H4.12983M23.6248 36.75H31.4998M31.4998 36.75H37.8698M35.4373 36.75V16.3607M35.4373 16.3607C34.3875 16.9664 33.1605 17.1903 31.9644 16.9945C30.7682 16.7986 29.6767 16.1951 28.8748 15.2862C27.9123 16.3747 26.5053 17.0625 24.9373 17.0625C24.1923 17.0632 23.4557 16.905 22.7767 16.5984C22.0977 16.2918 21.4919 15.8439 20.9998 15.2845C20.0373 16.3748 18.6303 17.0625 17.0623 17.0625C16.3173 17.0632 15.5807 16.905 14.9017 16.5984C14.2227 16.2918 13.6169 15.8439 13.1248 15.2845C12.3232 16.1936 11.2317 16.7975 10.0356 16.9937C8.83952 17.1898 7.61237 16.9662 6.56233 16.3607M35.4373 16.3607C36.1349 15.9581 36.7304 15.4003 37.1779 14.7306C37.6253 14.061 37.9127 13.2973 38.0178 12.4988C38.1228 11.7002 38.0428 10.8882 37.7838 10.1256C37.5247 9.36295 37.0937 8.67013 36.5241 8.10075L34.4416 6.02C33.9498 5.52758 33.2825 5.25061 32.5866 5.25H9.41133C8.71562 5.25015 8.04843 5.52647 7.55633 6.01825L5.47558 8.10075C4.90725 8.67079 4.47741 9.36373 4.2192 10.1262C3.961 10.8886 3.88132 11.7001 3.98632 12.4982C4.09133 13.2963 4.3782 14.0596 4.82482 14.7292C5.27144 15.3989 5.86589 15.9571 6.56233 16.3607M6.56233 36.75V16.3607M11.8123 31.5H18.3748C18.7229 31.5 19.0568 31.3617 19.3029 31.1156C19.549 30.8694 19.6873 30.5356 19.6873 30.1875V23.625C19.6873 23.2769 19.549 22.9431 19.3029 22.6969C19.0568 22.4508 18.7229 22.3125 18.3748 22.3125H11.8123C11.4642 22.3125 11.1304 22.4508 10.8843 22.6969C10.6381 22.9431 10.4998 23.2769 10.4998 23.625V30.1875C10.4998 30.912 11.0878 31.5 11.8123 31.5Z",
    stroke: "#4A66F9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_237_1595",
    x: -243,
    y: -73,
    width: 368,
    height: 253,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 27
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_237_1595"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_237_1595",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_237_1595"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1728,
    height: 1197,
    fill: "white",
    transform: "translate(-476 -176)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.407d7b7d1b0a6a9cb13ce097c9dccbde.svg";
export { ForwardRef as ReactComponent };